import type { ReactNode } from "react";
import { NavLink, useSearchParams } from "react-router";
import { ed } from "./styles";
import type { MastLink } from "./links";

/**
 * One line across the top: section nav on the left, the period (or any
 * short meta) on the right. Query params carry across the nav links.
 * `tabs` sets the nav as tabs sitting on the rule, for a hub page.
 */
export function Masthead({
  links = [],
  meta,
  label = "Section",
  variant = "rule",
}: {
  links?: MastLink[];
  meta?: ReactNode;
  /** Accessible name for the nav. */
  label?: string;
  variant?: "rule" | "tabs";
}) {
  const [searchParams] = useSearchParams();
  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";
  const tabs = variant === "tabs";
  return (
    <header className={tabs ? ed.tabMasthead : ed.masthead}>
      <nav className={tabs ? ed.tabNav : ed.mastNav} aria-label={label}>
        {links.map((l) => (
          <NavLink key={l.to} to={`${l.to}${suffix}`} end={l.end}>
            {l.label}
          </NavLink>
        ))}
      </nav>
      {meta && <span className={tabs ? ed.tabMeta : ed.mastMeta}>{meta}</span>}
    </header>
  );
}
